// src/data/certs.js
const CERTS = [
  "SAP Certified Development Associate — SAP Fiori Application Developer (C_FIORDEV_21)",
  "SAP Certified Development Associate — SAP Extension Suite (C_CPE_12)",
  "IBM Certified Agile Explorer",
  "IBM Design Thinking Practitioner",
  "IBM Cognitive Practitioner",
  "Microservices Fundamentals — IBM (Coursera)",
  "PG-DAC — C-DAC Pune",
];

export { CERTS };
export default CERTS;
